import { Box, Card, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";
import ReactApexChart from "react-apexcharts";
import useStatTotalEarn from "../../../../hooks/useStatTotalEarn";
import useStatTotalRedeem from "../../../../hooks/useStatTotalRedeem";
const useStyles = makeStyles((theme) => ({
  textHeaderStyle: {
    marginTop: 6,
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.blue,
  },
  cardContainer: {
    marginTop: 6,
    height: 152,
    width: 357,
    display: "flex",
    justifyContent: "start",
    boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",
    borderRadius: 8
  },
  card: {
    // width: 150,

    height: 50,
    display: "flex",
    justifyContent: "space-between",
  },
  radialOrangePoint: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: theme.orange,
  },
  radialGrayPoint: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: theme.darkGray2,
  },
  totalPointTextStyle: {
    margin: "auto 10px",
    fontSize: "0.8rem",
  },
  totalPointDataTextStyle: {
    margin: "auto 10px",
    fontWeight: "bold",
  },
  totalLoyaltyContainer: {
    display: "grid",
    gridTemplateRows: "50% 50%",
  },
  totalLoyaltyRow: {
    display: "grid",
    gridTemplateColumns: "50% 50%",
  },
}));
const option = {
  colors: ["#FA9917"],

  stroke: {
    show: true,
    curve: "smooth",
    lineCap: "butt",
    colors: undefined,
    width: 10,
    dashArray: 0,
  },
  chart: {
    height: 100,
    type: "radialBar",
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: "70%",
        background: "transparent",
      },
      track: {
        show: true,
        startAngle: undefined,
        endAngle: undefined,
        background: "#f2f2f2",
        strokeWidth: "97%",
        opacity: 1,
        margin: 0,
        dropShadow: {
          enabled: false,
          top: 0,
          left: 0,
          blur: 3,
          opacity: 0.5,
        },
      },

      dataLabels: {
        show: true,
        name: {
          show: true,
          fontSize: "9px",
          fontWeight: "normal",
          color: "#828282",
        },
        value: {
          show: true,
          fontSize: "20px",
          fontFamily: undefined,
          fontWeight: "bold",
          color: undefined,
          offsetY: 5,
          formatter: function (val) {
            return val.toFixed(2) + "%";
          },
        },
      },
    },
  },

  tooltip: {
    enabled: true,
    enabledOnSeries: undefined,
    shared: true,
    followCursor: false,
    intersect: false,
    inverseOrder: false,
    custom: undefined,
    fillSeriesColor: false,
    theme: false,
    style: {
      fontSize: "12px",
      fontFamily: undefined,
    },
    onDatasetHover: {
      highlightDataSeries: false,
    },
    x: {
      show: true,
      format: "dd MMM",
      formatter: undefined,
    },
    y: {
      formatter: undefined,
      title: {
        formatter: (seriesName) => seriesName + ": ",
      },
    },
    z: {
      formatter: undefined,
      title: "Size: ",
    },
    marker: {
      show: true,
    },
    items: {
      display: "flex",
    },
    fixed: {
      enabled: false,
      position: "topRight",
      offsetX: 0,
      offsetY: 0,
    },
  },
  labels: ["อัตราการแลกคะแนน"],
};
function LoyaltyComponent({ periodType, fromDate, toDate }) {
  const classes = useStyles();
  const translate = useTranslate();

  option.labels = [translate("ra.text.bi.loyalty.Redeemed")];

  const {
    earn: earnFilter,
    loading: earnLoading,
    error: earnError,
  } = useStatTotalEarn(periodType, fromDate, toDate);
  const {
    redeem: redeemFilter,
    loading: redeemLoading,
    error: redeemError,
  } = useStatTotalRedeem(periodType, fromDate, toDate);
  const {
    earn: totalPoint,
    loading: totalPointLoading,
    error: totalPointError,
  } = useStatTotalEarn("All", "2000-01-01", "2121-12-31");
  const {
    redeem: totalRedeem,
    loading: totalRedeemLoading,
    error: totalRedeemError,
  } = useStatTotalRedeem("All", "2000-01-01", "2121-12-31");

  if (earnLoading || redeemLoading || totalPointLoading || totalRedeemLoading)
    return null;
  if (earnError || redeemError || totalPointError || totalRedeemError)
    return null;

  let earn = earnFilter?.total_earn?.reduce((total, currentEarnValue) => {
    return total + currentEarnValue.value;
  }, 0);
  let redeem = redeemFilter?.total_redeem?.reduce(
    (total, currentRedeemValue) => {
      return total + currentRedeemValue.value;
    },
    0
  );

  let allEarn = 0,
    allRedeem = 0;
  if (totalPoint?.total_earn) {
    allEarn = totalPoint?.total_earn[0].value ?? 0;
  }
  if (totalRedeem?.total_redeem) {
    allRedeem = totalRedeem?.total_redeem[0].value ?? 0;
  }
  return (
    <Box>
      <Typography className={classes.textHeaderStyle}>
        {translate("ra.text.bi.loyalty.loyaltyPoints")}
      </Typography>
      <Card className={classes.cardContainer}>
        <Box>
          <ReactApexChart
            options={option}
            series={[allRedeem && allEarn ? (allRedeem * 100) / allEarn : 0]}
            type="radialBar"
            height={180}
            width={120}
          />
        </Box>
        <Box flex="3" marginTop={3}>
          <Box className={classes.totalLoyaltyContainer}>
            <Box className={classes.totalLoyaltyRow}>
              <Typography className={classes.totalPointTextStyle}>
                {translate("ra.text.bi.loyalty.totalPoint")}
              </Typography>
              <Typography
                align="right"
                className={classes.totalPointDataTextStyle}
              >
                {totalPoint?.total_earn
                  ? totalPoint?.total_earn[0].value.toLocaleString()
                  :0}
              </Typography>
            </Box>
            <Box className={classes.totalLoyaltyRow}>
              <Typography className={classes.totalPointTextStyle}>
                {translate("ra.text.bi.totalRemaining")}
              </Typography>
              <Typography
                align="right"
                className={classes.totalPointDataTextStyle}
              >
                {(allEarn - allRedeem).toLocaleString()}
              </Typography>
            </Box>
          </Box>
          <Box height="20px" />
          <Box
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <Box>
              <Typography style={{ fontSize: 10 }}>
                {translate("ra.text.bi.loyalty.Earn")}
              </Typography>
              <Typography align="center">{earn? earn.toLocaleString() :0}</Typography>
            </Box> 

            <Box>
              <Box display="flex">
                <Typography style={{ fontSize: 10 }}>
                  {translate("ra.text.bi.loyalty.Redeem")}
                </Typography>
              </Box>
              <Typography align="center">{redeem? redeem.toLocaleString() :0}</Typography>
            </Box>
            {/* <Box>
              <Box display="flex">
                <Box className={classes.radialGrayPoint} />
                <Typography style={{ fontSize: 10 }}>
                  {translate("ra.text.bi.loyalty.Remaining")}
                </Typography>
              </Box>
              <Typography align="center">
                {(earn - redeem).toLocaleString()}
              </Typography>
            </Box> */}
          </Box>
        </Box>
      </Card>
    </Box>
  );
}

export default LoyaltyComponent;
